const join = (...parts) =>
  parts
    .filter((part) => part !== undefined && part !== null && part !== "")
    .map((part) => String(part).replace(/(^\/+|\/+$)/g, ""))
    .filter(Boolean)
    .join("/");

const withSlash = (...parts) => `/${join(...parts)}`;

const paths = {
  pmDashboard: "/home",
  dashboard: "/dashboard",
  myTasks: "/my-tasks",
  chatSpace: "/chat-space",
  emailMessages: "/email-messages",
  accessControl: "/access-control",
  operations: "/operations",
  incidents: "/incidents",
  tickets: "/tickets",
  troubleshootingGuides: "/troubleshooting-guides",
  docs: "/docs",
  docDetails: (docId) => withSlash("docs", docId),
  incidentCreate: () => withSlash("incidents", "new"),
  incidentDetails: (incidentId) => withSlash("incidents", incidentId),
  incidentEdit: (incidentId) => withSlash("incidents", incidentId, "edit"),
  ticketCreate: () => withSlash("tickets", "new"),
  ticketDetails: (ticketId) => withSlash("tickets", ticketId),
  ticketEdit: (ticketId) => withSlash("tickets", ticketId, "edit"),
  troubleshootingGuideCreate: () => withSlash("troubleshooting-guides", "new"),
  troubleshootingGuideDetails: (guideId) => withSlash("troubleshooting-guides", guideId),
  troubleshootingGuideEdit: (guideId) => withSlash("troubleshooting-guides", guideId, "edit"),
  projects: "/projects",
  users: "/users",
  workspaces: "/workspaces",
  partners: "/partners",
  partnerCommissions: "/partners/commissions",
  workspaceCreate: () => withSlash("workspaces", "new"),
  workspaceDetails: (workspaceId) =>
    withSlash("workspaces", workspaceId),
  workspaceMemberDetails: (workspaceId, userId) =>
    withSlash("workspaces", workspaceId, "members", userId),
  workspaceInvitationAccept: "/workspaces/invitations/accept",
  workspaceInvitation: (workspaceId, invitationId) =>
    withSlash("workspaces", workspaceId, "invitations", invitationId),
  workspaceSubscriptions: (workspaceId) =>
    withSlash("workspaces", workspaceId, "subscriptions"),
  workspacePaymentMethods: (workspaceId) =>
    withSlash("workspaces", workspaceId, "payment-methods"),
  workspaceOrganization: (workspaceId) =>
    withSlash("workspaces", workspaceId, "organization"),
  workspaceCharges: (workspaceId) =>
    withSlash("workspaces", workspaceId, "charges"),
  userCreate: "/users/new",
  userEdit: (userId) => withSlash("users", userId, "edit"),
  backlog: "/backlog",
  iterations: "/iterations",
  tags: "/tags",
  team: "/team",
  reports: "/reports",
  settings: "/settings",
  feedback: "/feedback",
  help: "/app/help",
  support: "/support",
  profile: "/profile",
  simpleLogin: "/login",
  getStarted: "/get-started",
  simpleSignup: "/auth/signup",
  authLanding: "/login",
  appleSetup: "/auth/apple-setup",
  socialSetup: "/auth/social-setup",
  linkedInCallback: "/auth/linkedin/callback",
  simpleLogout: "/auth/logout",
  simpleSessionExpired: "/auth/session-expired",
  simpleRecoverRequest: "/auth/recover",
  simpleVerificationCode: "/auth/verify",
  simpleResetPassword: "/auth/reset",
  simpleAccountRecoverySuccess: "/auth/recovered",
  linkedInCallback: "/auth/linkedin/callback",
  cardLogin: "/auth/login",
  cardLogout: "/auth/logout",
  projectCreate: () => withSlash("projects", "new"),
  projectEdit: (projectId) => withSlash("projects", projectId, "edit"),
  projectDetails: (projectId) => withSlash("projects", projectId),
  projectIterationCreate: (projectId) =>
    withSlash("projects", projectId, "iterations", "new"),
  projectIterationEdit: (projectId, iterationId) =>
    withSlash("projects", projectId, "iterations", iterationId, "edit"),
  projectIterationDetails: (projectId, iterationId) =>
    withSlash("projects", projectId, "iterations", iterationId),
  projectTaskCreate: (projectId, iterationId) =>
    withSlash("projects", projectId, "iterations", iterationId, "tasks", "new"),
  projectTaskEdit: (projectId, iterationId, taskId) =>
    withSlash(
      "projects",
      projectId,
      "iterations",
      iterationId,
      "tasks",
      taskId,
      "edit",
    ),
  projectTaskDetails: (projectId, iterationId, taskId) =>
    withSlash("projects", projectId, "iterations", iterationId, "tasks", taskId),

  qaTestRuns: "/qa-test-runs",
  qaTestRunsFeatures: (appId) => withSlash("qa-test-runs", "apps", appId, "features"),
  qaTestRunsAppHistory: (appId) => withSlash("qa-test-runs", "apps", appId, "history"),
  qaTestRunsFeatureHistory: (appId, featureId) =>
    withSlash("qa-test-runs", "apps", appId, "features", featureId, "history"),
};

export default paths;
